Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint max-len: 0 */

// source https://yeun.github.io/open-color/
var allColors = exports.allColors = {
  red: ['#fff5f5', '#ffe3e3', '#ffc9c9', '#ffa8a8', '#ff8787', '#ff6b6b', '#fa5252', '#f03e3e', '#e03131', '#c92a2a'],
  pink: ['#fff0f6', '#ffdeeb', '#fcc2d7', '#faa2c1', '#f783ac', '#f06595', '#e64980', '#d6336c', '#c2255c', '#a61e4d'],
  grape: ['#f8f0fc', '#f3d9fa', '#eebefa', '#e599f7', '#da77f2', '#cc5de8', '#be4bdb', '#ae3ec9', '#9c36b5', '#862e9c'],
  violet: ['#f3f0ff', '#e5dbff', '#d0bfff', '#b197fc', '#9775fa', '#845ef7', '#7950f2', '#7048e8', '#6741d9', '#5f3dc4'],
  indigo: ['#edf2ff', '#dbe4ff', '#bac8ff', '#91a7ff', '#748ffc', '#5c7cfa', '#4c6ef5', '#4263eb', '#3b5bdb', '#364fc7'],
  blue: ['#e8f7ff', '#ccedff', '#a3daff', '#72c3fc', '#4dadf7', '#329af0', '#228ae6', '#1c7cd6', '#1b6ec2', '#1862ab'],
  cyan: ['#e3fafc', '#c5f6fa', '#99e9f2', '#66d9e8', '#3bc9db', '#22b8cf', '#15aabf', '#1098ad', '#0c8599', '#0b7285'],
  teal: ['#e6fcf5', '#c3fae8', '#96f2d7', '#63e6be', '#38d9a9', '#20c997', '#12b886', '#0ca678', '#099268', '#087f5b'],
  green: ['#ebfbee', '#d3f9d8', '#b2f2bb', '#8ce99a', '#69db7c', '#51cf66', '#40c057', '#37b24d', '#2f9e44', '#2b8a3e'],
  lime: ['#f4fce3', '#e9fac8', '#d8f5a2', '#c0eb75', '#a9e34b', '#94d82d', '#82c91e', '#74b816', '#66a80f', '#5c940d'],
  yellow: ['#fff9db', '#fff3bf', '#ffec99', '#ffe066', '#ffd43b', '#fcc419', '#fab005', '#f59f00', '#f08c00', '#e67700'],
  orange: ['#fff4e6', '#ffe8cc', '#ffd8a8', '#ffc078', '#ffa94d', '#ff922b', '#fd7e14', '#f76707', '#e8590c', '#d9480f']
};

var grayColors = exports.grayColors = ['#f8f9fa', '#f1f3f5', '#e9ecef', '#dee2e6', '#ced4da', '#adb5bd', '#868e96', '#495057', '#343a40', '#212529'];

var getPaletteForBrightness = exports.getPaletteForBrightness = function getPaletteForBrightness() {
  var brightness = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 6;
  var hues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['cyan', 'yellow', 'pink', 'grape', 'blue', 'lime', 'teal', 'red', 'violet', 'orange', 'indigo', 'green'];

  // sanity check indices
  var index = Math.max(0, Math.min(brightness, allColors.red.length - 1));

  // filter non-sensical hues
  return hues.map(function (hue) {
    return allColors[hue] && allColors[hue][index];
  }).filter(function (val) {
    return val;
  });
};

var primaryHue = 'cyan';

var colorHues = exports.colorHues = Object.keys(allColors).sort();
var textColor = exports.textColor = grayColors[7];

exports['default'] = {
  'default': allColors[primaryHue][5],
  dark: allColors[primaryHue][7],
  light: allColors[primaryHue][3],

  disabled: textColor,
  lightDisabled: grayColors[3],

  text: textColor,
  black: grayColors[9],
  darkGray: grayColors[8],
  lightGray: grayColors[3],

  grid: grayColors[4],
  gridDark: grayColors[8],
  label: textColor,
  tickLabel: textColor,

  grays: grayColors,
  categories: [].concat(_toConsumableArray(getPaletteForBrightness(6)), _toConsumableArray(getPaletteForBrightness(2)))
};